import { Divider } from "primereact/divider";

interface IDividerProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  layout?: "horizontal" | "vertical";
}

const REIDivider: React.FC<IDividerProps> = ({ children, className, layout = "horizontal" }) => (
  <Divider className={className} layout={layout}>
    {children}
  </Divider>
);

export default REIDivider;
